<mat-menu #gpsStatusDetails class="gnss-details-panel">
  <span
    mat-menu-item
    style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin-left: 1em; margin-right: 1em"
    matTooltip="Global Navigation Satellite System (GPS, GLONASS, etc.)"
    >GNSS Status</span
    >
    <mat-divider></mat-divider>
    <span mat-menu-item style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin-left: 1em; margin-right: 1em"
      >Last Updated: {{ latestPos?.timestamp | timeAgo }}</span
      >
      <span mat-menu-item style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin-left: 1em; margin-right: 1em"
        >Est. Accuracy: {{ latestPos?.coords?.accuracy | distance }}</span
        >
        <span mat-menu-item style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin-left: 1em; margin-right: 1em"
          >Latitude: {{ latestPos?.coords?.latitude | number: '1.1-7' }}&deg;</span
          >
          <span mat-menu-item style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin-left: 1em; margin-right: 1em"
            >Longitude: {{ latestPos?.coords?.longitude | number: '1.1-7' }}&deg;</span
            >
          </mat-menu>
          <button type="button" mat-icon-button [matMenuTriggerFor]="gpsStatusDetails" matTooltip="GNSS Status: {{ gpsStatus }}">
            @if (gpsStatus === GpsStatuses.UNKNOWN) {
              <mat-icon>location_disabled</mat-icon>
            }
            @if (gpsStatus === GpsStatuses.ERROR) {
              <mat-icon color="accent">location_disabled</mat-icon>
            }
            @if (gpsStatus === GpsStatuses.BAD_FIX) {
              <mat-icon>location_searching</mat-icon>
            }
            @if (gpsStatus === GpsStatuses.GOOD_FIX) {
              <mat-icon>my_location</mat-icon>
            }
          </button>
